import React from 'react';
import ContactUs from '../../About/ContactUs/ContactUs';
import OurWorkBanner from '../OurWorkBanner/OurWorkBanner';
import WorkCaseStudies from '../WorkCaseStudies/WorkCaseStudies';

const OurWork = () => {
    return (
        <div>
            <OurWorkBanner />
            <WorkCaseStudies />
            <ContactUs />
        </div>
    );
};

export default OurWork;